// Selectors
export const employerDataSelector = ({ generalReducer: { employer }, }) => ({
    ...employer,
});
export const employerNewDataSelector = ({ generalReducer: { employerNew }, }) => ({
    ...employerNew,
});
export const searchEmployerSelector = ({ generalReducer: { employer }, }) => ({
    value: employer.value,
});
